import { useAttributesContext } from "shared/contexts/AttributesContext";
import { ContextProviderName } from "shared/contexts/types";
import { WORK_ORDER_PARTS_GENERIC_FILTER } from "shared/filterDefinitions";

import usePartSchema from "./partSchema";
import { SchemaEntryOverride, UseSchema } from "./types";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

const useWorkOrderPartsSchema = (accessorsToHide: string[] = []): UseSchema => {
  const { attributes } = useAttributesContext(
    ContextProviderName.WorkOrderParts
  );

  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    WORK_ORDER_PARTS_GENERIC_FILTER,
    attributeMap
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const overrides: SchemaEntryOverride = {};

  const relationships = {
    "/api/v1/parts": usePartSchema(),
  };

  const schema = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    overrides,
    relationships,
    accessorsToHide
  );

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
    getSchemaForAccessor,
    getSchemaEntry,
  };
};

export default useWorkOrderPartsSchema;
